var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m411.935 512h-311.87c-20.205 0-38.153-10.529-48.012-28.167-9.857-17.636-9.424-38.44 1.162-55.649l127.781-207.742v-205.434h150.006v205.434l127.781 207.742v.001c10.586 17.209 11.02 38.013 1.162 55.649-9.857 17.637-27.805 28.166-48.01 28.166z",
    fill: "#d1f7ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m458.784 428.184-127.781-207.742v-205.434h-75.001v496.992h155.933c20.205 0 38.153-10.529 48.012-28.167 9.857-17.636 9.423-38.439-1.163-55.649z",
    fill: "#a3efff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m53.216 428.184c-10.586 17.209-11.02 38.013-1.162 55.649 9.858 17.638 27.806 28.167 48.011 28.167h311.869c20.205 0 38.153-10.529 48.012-28.167 9.857-17.636 9.424-38.44-1.162-55.649v-.001l-75.772-123.186h-254.025z",
    fill: "#67e57e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m458.784 428.184-75.772-123.186h-127.01v207.002h155.933c20.205 0 38.153-10.529 48.012-28.167 9.857-17.636 9.423-38.439-1.163-55.649z",
    fill: "#4dc979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m346.005 30h-180.01c-8.284 0-15-6.716-15-15s6.716-15 15-15h180.01c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#72c5fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256.002 30h90.003c8.284 0 15-6.716 15-15 0-8.224-6.62-14.894-14.821-14.991h-90.182z",
    fill: "#37a8e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m331.003 220.442v-.446h-38.47c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.648z",
    fill: "#2698d1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#176cad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.786 289.998h-39.256c-8.284 0-15 6.716-15 15s6.716 15 15 15h57.709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.843 359.998h-39.315c-8.284 0-15 6.716-15 15s6.716 15 15 15h57.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.525 444.494c0 8.284 6.716 15 15 15h46.457c.485-10.289-1.999-20.64-7.422-30h-39.036c-8.283 0-14.999 6.716-14.999 15z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m282.533 179.995h48.47v-30h-48.47c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#2698d1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m282.533 109.994h48.47v-30h-48.47c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#2698d1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabIcon);
export default __webpack_public_path__ + "static/media/LabIcon.94bfb640.svg";
export { ForwardRef as ReactComponent };